import { twMerge } from 'tailwind-merge';

export interface InfoProps {
  name: string;
  label: string;
  customClassName?: string;
}

export const Info = ({ label, customClassName }: InfoProps) => (
  <div className={twMerge(['mb-4', customClassName])} dangerouslySetInnerHTML={{ __html: label }} />
);
